"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScoreChip = void 0;
const scoreColor_1 = __importDefault(require("@opsbase/lib-grading/scoreColor"));
const Tooltip_1 = __importDefault(require("@opsbase/web-ui/Tooltip"));
const react_1 = __importDefault(require("react"));
const Chip_1 = __importDefault(require("../Chip"));
function ScoreChip(props) {
    const { scoreTotal, scoreMax } = props;
    const value = Math.round((((scoreTotal || 0) / scoreMax) * 100 + Number.EPSILON) * 100) / 100;
    const tip = (scoreTotal || 0) + ' / ' + scoreMax;
    return (react_1.default.createElement(Tooltip_1.default, { tip: tip },
        react_1.default.createElement(Chip_1.default, { color: (0, scoreColor_1.default)(value), label: value + '%' })));
}
exports.ScoreChip = ScoreChip;
exports.default = ScoreChip;
